// extracted by mini-css-extract-plugin
export default {"trustedRetailerBanner":"yU-z","trustedRetailerTooltipWrapper":"zU-z"};